import { useNavigate } from "react-router-dom";

import APButton from "./APButton";
import { APIconName } from "./APIcon";

type HomeDestination = "default" | "dossiersHome" | "dossierHome";

const HomeButton = ({
  onClick,
  replaceLocation,
  destination = "default",
  dossierId,
}: {
  onClick?: () => void;
  replaceLocation?: boolean;
  destination?: HomeDestination;
  dossierId?: string;
}) => {
  const navigate = useNavigate();

  let destinationUrl: string;
  let icon: APIconName | undefined;

  switch (destination) {
    case "default":
      destinationUrl = "/";
      break;
    case "dossiersHome":
      destinationUrl = "/dossiers";
      icon = "car";
      break;
    case "dossierHome":
      destinationUrl = `/dossiers/${dossierId}`;
      icon = "car";
      break;
  }

  const handleHome = () => {
    if (replaceLocation) {
      location.replace(destinationUrl);
    } else {
      navigate(destinationUrl, { replace: false });
    }
  };

  return <APButton text="Home" onClick={onClick || handleHome} icon={icon} />;
};

export default HomeButton;
